module.exports = __webpack_public_path__ + "img/side_post.2ab0f037.png";